import styled from "styled-components/native";
import ReviewPageCard from "./ReviewPageCard";
import { SpaceType } from "@components/atoms/Spacer/types";
import PriceCardContainer from "./PriceCardContainer";
import React from "react";

const SettingCard = ({
  settingItemDetails,
  toggleGalleryItem,
  fromRequest,
  selectedType,
  isFirstBreadcrumbJewelryDetailPage = false,
  startFromSetting = false,
}: any) => {
  return (
    <Overlay>
      <ReviewPageCard
        key={settingItemDetails?.id}
        itemDetail={settingItemDetails}
        type={"setting"}
        toggleGalleryItem={toggleGalleryItem}
        fromRequest={fromRequest}
        selectedType={selectedType}
        isFirstBreadcrumbJewelryDetailPage={isFirstBreadcrumbJewelryDetailPage}
        startFromSetting={startFromSetting}
      />
      <PriceCardContainer itemDetail={settingItemDetails} type={"setting"} />
    </Overlay>
  );
};

export default SettingCard;

const Overlay = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: ${SpaceType.Basic}px;
  margin-bottom: ${SpaceType.Double}px;
`;
